'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _SyntaxHighlight = require('../elements/SyntaxHighlight');

var _SyntaxHighlight2 = _interopRequireDefault(_SyntaxHighlight);

var _languageHandler = require('../../../languageHandler');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Field = require('../elements/Field');

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DevtoolsComponent = function (_React$Component) {
    (0, _inherits3.default)(DevtoolsComponent, _React$Component);

    function DevtoolsComponent() {
        (0, _classCallCheck3.default)(this, DevtoolsComponent);
        return (0, _possibleConstructorReturn3.default)(this, (DevtoolsComponent.__proto__ || (0, _getPrototypeOf2.default)(DevtoolsComponent)).apply(this, arguments));
    }

    return DevtoolsComponent;
}(_react2.default.Component); /*
                              Copyright 2017 Michael Telatynski <7t3chguy@gmail.com>
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

DevtoolsComponent.contextTypes = {
    roomId: _propTypes2.default.string.isRequired
};

var GenericEditor = function (_DevtoolsComponent) {
    (0, _inherits3.default)(GenericEditor, _DevtoolsComponent);

    // static propTypes = {onBack: PropTypes.func.isRequired};

    function GenericEditor(props, context) {
        (0, _classCallCheck3.default)(this, GenericEditor);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (GenericEditor.__proto__ || (0, _getPrototypeOf2.default)(GenericEditor)).call(this, props, context));

        _this2._onChange = _this2._onChange.bind(_this2);
        _this2.onBack = _this2.onBack.bind(_this2);
        return _this2;
    }

    (0, _createClass3.default)(GenericEditor, [{
        key: 'onBack',
        value: function onBack() {
            if (this.state.message) {
                this.setState({ message: null });
            } else {
                this.props.onBack();
            }
        }
    }, {
        key: '_onChange',
        value: function _onChange(e) {
            this.setState((0, _defineProperty3.default)({}, e.target.id, e.target.type === 'checkbox' ? e.target.checked : e.target.value));
        }
    }, {
        key: '_buttons',
        value: function _buttons() {
            return _react2.default.createElement(
                'div',
                { className: 'mx_Dialog_buttons' },
                _react2.default.createElement(
                    'button',
                    { onClick: this.onBack },
                    (0, _languageHandler._t)('Back')
                ),
                !this.state.message && _react2.default.createElement(
                    'button',
                    { onClick: this._send },
                    (0, _languageHandler._t)('Send')
                )
            );
        }
    }, {
        key: 'textInput',
        value: function textInput(id, label) {
            return _react2.default.createElement(_Field2.default, { id: id, label: label, size: '42', autoFocus: true, type: 'text', autoComplete: 'on',
                value: this.state[id], onChange: this._onChange });
        }
    }]);
    return GenericEditor;
}(DevtoolsComponent);

var SendCustomEvent = function (_GenericEditor) {
    (0, _inherits3.default)(SendCustomEvent, _GenericEditor);
    (0, _createClass3.default)(SendCustomEvent, null, [{
        key: 'getLabel',
        value: function getLabel() {
            return (0, _languageHandler._t)('Send Custom Event');
        }
    }]);

    function SendCustomEvent(props, context) {
        (0, _classCallCheck3.default)(this, SendCustomEvent);

        var _this3 = (0, _possibleConstructorReturn3.default)(this, (SendCustomEvent.__proto__ || (0, _getPrototypeOf2.default)(SendCustomEvent)).call(this, props, context));

        _this3._send = _this3._send.bind(_this3);

        var _Object$assign = (0, _assign2.default)({
            eventType: '',
            stateKey: '',
            evContent: '{\n\n}'
        }, _this3.props.inputs),
            eventType = _Object$assign.eventType,
            stateKey = _Object$assign.stateKey,
            evContent = _Object$assign.evContent;

        _this3.state = {
            isStateEvent: Boolean(_this3.props.forceStateEvent),

            eventType: eventType,
            stateKey: stateKey,
            evContent: evContent
        };
        return _this3;
    }

    (0, _createClass3.default)(SendCustomEvent, [{
        key: 'send',
        value: function send(content) {
            var cli = _MatrixClientPeg2.default.get();
            if (this.state.isStateEvent) {
                return cli.sendStateEvent(this.context.roomId, this.state.eventType, content, this.state.stateKey);
            } else {
                return cli.sendEvent(this.context.roomId, this.state.eventType, content);
            }
        }
    }, {
        key: '_send',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var message, content;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(this.state.eventType === '')) {
                                    _context.next = 3;
                                    break;
                                }

                                this.setState({ message: (0, _languageHandler._t)('You must specify an event type!') });
                                return _context.abrupt('return');

                            case 3:
                                message = void 0;
                                _context.prev = 4;
                                content = JSON.parse(this.state.evContent);
                                _context.next = 8;
                                return (0, _bluebird.resolve)(this.send(content));

                            case 8:
                                message = (0, _languageHandler._t)('Event sent!');
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](4);

                                message = (0, _languageHandler._t)('Failed to send custom event.') + ' (' + _context.t0.toString() + ')';

                            case 14:
                                this.setState({ message: message });

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 11]]);
            }));

            function _send() {
                return _ref.apply(this, arguments);
            }

            return _send;
        }()
    }, {
        key: 'render',
        value: function render() {
            if (this.state.message) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_content' },
                        this.state.message
                    ),
                    this._buttons()
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_DevTools_content' },
                    this.textInput('eventType', (0, _languageHandler._t)('Event Type')),
                    this.state.isStateEvent && this.textInput('stateKey', (0, _languageHandler._t)('State Key')),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_Field2.default, { id: 'evContent', label: (0, _languageHandler._t)("Event Content"), type: 'text', className: 'mx_DevTools_textarea',
                        autoComplete: 'off', value: this.state.evContent, onChange: this._onChange, element: 'textarea' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_buttons' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.onBack },
                        (0, _languageHandler._t)('Back')
                    ),
                    !this.state.message && _react2.default.createElement(
                        'button',
                        { onClick: this._send },
                        (0, _languageHandler._t)('Send')
                    ),
                    !this.state.message && !this.props.forceStateEvent && _react2.default.createElement(
                        'div',
                        { style: { float: "right" } },
                        _react2.default.createElement('input', { id: 'isStateEvent', className: 'mx_DevTools_tgl mx_DevTools_tgl-flip', type: 'checkbox', onChange: this._onChange, checked: this.state.isStateEvent }),
                        _react2.default.createElement('label', { className: 'mx_DevTools_tgl-btn', 'data-tg-off': 'Event', 'data-tg-on': 'State Event', htmlFor: 'isStateEvent' })
                    )
                )
            );
        }
    }]);
    return SendCustomEvent;
}(GenericEditor);

SendCustomEvent.propTypes = {
    onBack: _propTypes2.default.func.isRequired,
    forceStateEvent: _propTypes2.default.bool,
    inputs: _propTypes2.default.object
};

var SendAccountData = function (_GenericEditor2) {
    (0, _inherits3.default)(SendAccountData, _GenericEditor2);
    (0, _createClass3.default)(SendAccountData, null, [{
        key: 'getLabel',
        value: function getLabel() {
            return (0, _languageHandler._t)('Send Account Data');
        }
    }]);

    function SendAccountData(props, context) {
        (0, _classCallCheck3.default)(this, SendAccountData);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (SendAccountData.__proto__ || (0, _getPrototypeOf2.default)(SendAccountData)).call(this, props, context));

        _this4._send = _this4._send.bind(_this4);

        var _Object$assign3 = (0, _assign2.default)({
            eventType: '',
            evContent: '{\n\n}'
        }, _this4.props.inputs),
            eventType = _Object$assign3.eventType,
            evContent = _Object$assign3.evContent;

        _this4.state = {
            isRoomAccountData: Boolean(_this4.props.isRoomAccountData),

            eventType: eventType,
            evContent: evContent
        };
        return _this4;
    }

    (0, _createClass3.default)(SendAccountData, [{
        key: 'send',
        value: function send(content) {
            var cli = _MatrixClientPeg2.default.get();
            if (this.state.isRoomAccountData) {
                return cli.setRoomAccountData(this.context.roomId, this.state.eventType, content);
            }
            return cli.setAccountData(this.state.eventType, content);
        }
    }, {
        key: '_send',
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var message, content;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(this.state.eventType === '')) {
                                    _context2.next = 3;
                                    break;
                                }

                                this.setState({ message: (0, _languageHandler._t)('You must specify an event type!') });
                                return _context2.abrupt('return');

                            case 3:
                                message = void 0;
                                _context2.prev = 4;
                                content = JSON.parse(this.state.evContent);
                                _context2.next = 8;
                                return (0, _bluebird.resolve)(this.send(content));

                            case 8:
                                message = (0, _languageHandler._t)('Event sent!');
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](4);

                                message = (0, _languageHandler._t)('Failed to send custom event.') + ' (' + _context2.t0.toString() + ')';

                            case 14:
                                this.setState({ message: message });

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[4, 11]]);
            }));

            function _send() {
                return _ref2.apply(this, arguments);
            }

            return _send;
        }()
    }, {
        key: 'render',
        value: function render() {
            if (this.state.message) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_content' },
                        this.state.message
                    ),
                    this._buttons()
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_DevTools_content' },
                    this.textInput('eventType', (0, _languageHandler._t)('Event Type')),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_Field2.default, { id: 'evContent', label: (0, _languageHandler._t)("Event Content"), type: 'text', className: 'mx_DevTools_textarea',
                        autoComplete: 'off', value: this.state.evContent, onChange: this._onChange, element: 'textarea' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_buttons' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.onBack },
                        (0, _languageHandler._t)('Back')
                    ),
                    !this.state.message && _react2.default.createElement(
                        'button',
                        { onClick: this._send },
                        (0, _languageHandler._t)('Send')
                    ),
                    !this.state.message && _react2.default.createElement(
                        'div',
                        { style: { float: "right" } },
                        _react2.default.createElement('input', { id: 'isRoomAccountData', className: 'mx_DevTools_tgl mx_DevTools_tgl-flip', type: 'checkbox', onChange: this._onChange, checked: this.state.isRoomAccountData, disabled: this.props.forceMode }),
                        _react2.default.createElement('label', { className: 'mx_DevTools_tgl-btn', 'data-tg-off': 'Account Data', 'data-tg-on': 'Room Data', htmlFor: 'isRoomAccountData' })
                    )
                )
            );
        }
    }]);
    return SendAccountData;
}(GenericEditor);

SendAccountData.propTypes = {
    isRoomAccountData: _propTypes2.default.bool,
    forceMode: _propTypes2.default.bool,
    inputs: _propTypes2.default.object
};


var INITIAL_LOAD_TILES = 20;
var LOAD_TILES_STEP_SIZE = 50;

var FilteredList = function (_React$Component2) {
    (0, _inherits3.default)(FilteredList, _React$Component2);
    (0, _createClass3.default)(FilteredList, null, [{
        key: 'filterChildren',
        value: function filterChildren(children, query) {
            if (!query) return children;
            var lcQuery = query.toLowerCase();
            return children.filter(function (child) {
                return child.key.toLowerCase().includes(lcQuery);
            });
        }
    }]);

    function FilteredList(props, context) {
        (0, _classCallCheck3.default)(this, FilteredList);

        var _this5 = (0, _possibleConstructorReturn3.default)(this, (FilteredList.__proto__ || (0, _getPrototypeOf2.default)(FilteredList)).call(this, props, context));

        _this5.showAll = function () {
            _this5.setState({
                truncateAt: _this5.state.truncateAt + LOAD_TILES_STEP_SIZE
            });
        };

        _this5.createOverflowElement = function (overflowCount, totalCount) {
            return _react2.default.createElement(
                'button',
                { className: 'mx_DevTools_RoomStateExplorer_button', onClick: _this5.showAll },
                (0, _languageHandler._t)("and %(count)s others...", { count: overflowCount })
            );
        };

        _this5.onQuery = function (ev) {
            if (_this5.props.onChange) _this5.props.onChange(ev.target.value);
        };

        _this5.getChildren = function (start, end) {
            return _this5.state.filteredChildren.slice(start, end);
        };

        _this5.getChildCount = function () {
            return _this5.state.filteredChildren.length;
        };

        _this5.state = {
            filteredChildren: FilteredList.filterChildren(_this5.props.children, _this5.props.query),
            truncateAt: INITIAL_LOAD_TILES
        };
        return _this5;
    }

    (0, _createClass3.default)(FilteredList, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.children === nextProps.children && this.props.query === nextProps.query) return;
            this.setState({
                filteredChildren: FilteredList.filterChildren(nextProps.children, nextProps.query),
                truncateAt: INITIAL_LOAD_TILES
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var TruncatedList = _index2.default.getComponent("elements.TruncatedList");
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Field2.default, { id: 'DevtoolsDialog_FilteredList_filter', label: (0, _languageHandler._t)('Filter results'), autoFocus: true, size: 64,
                    type: 'text', autoComplete: 'off', value: this.props.query, onChange: this.onQuery,
                    className: 'mx_TextInputDialog_input mx_DevTools_RoomStateExplorer_query'
                    // force re-render so that autoFocus is applied when this component is re-used
                    , key: this.props.children[0] ? this.props.children[0].key : '' }),
                _react2.default.createElement(TruncatedList, { getChildren: this.getChildren,
                    getChildCount: this.getChildCount,
                    truncateAt: this.state.truncateAt,
                    createOverflowElement: this.createOverflowElement })
            );
        }
    }]);
    return FilteredList;
}(_react2.default.Component);

FilteredList.propTypes = {
    children: _propTypes2.default.any,
    query: _propTypes2.default.string,
    onChange: _propTypes2.default.func
};

var RoomStateExplorer = function (_DevtoolsComponent2) {
    (0, _inherits3.default)(RoomStateExplorer, _DevtoolsComponent2);
    (0, _createClass3.default)(RoomStateExplorer, null, [{
        key: 'getLabel',
        value: function getLabel() {
            return (0, _languageHandler._t)('Explore Room State');
        }
    }]);

    function RoomStateExplorer(props, context) {
        (0, _classCallCheck3.default)(this, RoomStateExplorer);

        var _this6 = (0, _possibleConstructorReturn3.default)(this, (RoomStateExplorer.__proto__ || (0, _getPrototypeOf2.default)(RoomStateExplorer)).call(this, props, context));

        var room = _MatrixClientPeg2.default.get().getRoom(_this6.context.roomId);
        _this6.roomStateEvents = room.currentState.events;

        _this6.onBack = _this6.onBack.bind(_this6);
        _this6.editEv = _this6.editEv.bind(_this6);
        _this6.onQueryEventType = _this6.onQueryEventType.bind(_this6);
        _this6.onQueryStateKey = _this6.onQueryStateKey.bind(_this6);

        _this6.state = {
            eventType: null,
            event: null,
            editing: false,

            queryEventType: '',
            queryStateKey: ''
        };
        return _this6;
    }

    (0, _createClass3.default)(RoomStateExplorer, [{
        key: 'browseEventType',
        value: function browseEventType(eventType) {
            var _this7 = this;

            return function () {
                _this7.setState({ eventType: eventType });
            };
        }
    }, {
        key: 'onViewSourceClick',
        value: function onViewSourceClick(event) {
            var _this8 = this;

            return function () {
                _this8.setState({ event: event });
            };
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            if (this.state.editing) {
                this.setState({ editing: false });
            } else if (this.state.event) {
                this.setState({ event: null });
            } else if (this.state.eventType) {
                this.setState({ eventType: null });
            } else {
                this.props.onBack();
            }
        }
    }, {
        key: 'editEv',
        value: function editEv() {
            this.setState({ editing: true });
        }
    }, {
        key: 'onQueryEventType',
        value: function onQueryEventType(filterEventType) {
            this.setState({ queryEventType: filterEventType });
        }
    }, {
        key: 'onQueryStateKey',
        value: function onQueryStateKey(filterStateKey) {
            this.setState({ queryStateKey: filterStateKey });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            if (this.state.event) {
                if (this.state.editing) {
                    return _react2.default.createElement(SendCustomEvent, { forceStateEvent: true, onBack: this.onBack, inputs: {
                            eventType: this.state.event.getType(),
                            evContent: (0, _stringify2.default)(this.state.event.getContent(), null, '\t'),
                            stateKey: this.state.event.getStateKey()
                        } });
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'mx_ViewSource' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_content' },
                        _react2.default.createElement(
                            _SyntaxHighlight2.default,
                            { className: 'json' },
                            (0, _stringify2.default)(this.state.event.event, null, 2)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_buttons' },
                        _react2.default.createElement(
                            'button',
                            { onClick: this.onBack },
                            (0, _languageHandler._t)('Back')
                        ),
                        _react2.default.createElement(
                            'button',
                            { onClick: this.editEv },
                            (0, _languageHandler._t)('Edit')
                        )
                    )
                );
            }

            var list = null;

            var classes = 'mx_DevTools_RoomStateExplorer_button';
            if (this.state.eventType === null) {
                list = _react2.default.createElement(
                    FilteredList,
                    { query: this.state.queryEventType, onChange: this.onQueryEventType },
                    (0, _keys2.default)(this.roomStateEvents).map(function (evType) {
                        var stateGroup = _this9.roomStateEvents[evType];
                        var stateKeys = (0, _keys2.default)(stateGroup);

                        var onClickFn = void 0;
                        if (stateKeys.length === 1 && stateKeys[0] === '') {
                            onClickFn = _this9.onViewSourceClick(stateGroup[stateKeys[0]]);
                        } else {
                            onClickFn = _this9.browseEventType(evType);
                        }

                        return _react2.default.createElement(
                            'button',
                            { className: classes, key: evType, onClick: onClickFn },
                            evType
                        );
                    })
                );
            } else {
                var stateGroup = this.roomStateEvents[this.state.eventType];

                list = _react2.default.createElement(
                    FilteredList,
                    { query: this.state.queryStateKey, onChange: this.onQueryStateKey },
                    (0, _keys2.default)(stateGroup).map(function (stateKey) {
                        var ev = stateGroup[stateKey];
                        return _react2.default.createElement(
                            'button',
                            { className: classes, key: stateKey, onClick: _this9.onViewSourceClick(ev) },
                            stateKey
                        );
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_content' },
                    list
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_buttons' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.onBack },
                        (0, _languageHandler._t)('Back')
                    )
                )
            );
        }
    }]);
    return RoomStateExplorer;
}(DevtoolsComponent);

RoomStateExplorer.propTypes = {
    onBack: _propTypes2.default.func.isRequired
};

var AccountDataExplorer = function (_DevtoolsComponent3) {
    (0, _inherits3.default)(AccountDataExplorer, _DevtoolsComponent3);
    (0, _createClass3.default)(AccountDataExplorer, null, [{
        key: 'getLabel',
        value: function getLabel() {
            return (0, _languageHandler._t)('Explore Account Data');
        }
    }]);

    function AccountDataExplorer(props, context) {
        (0, _classCallCheck3.default)(this, AccountDataExplorer);

        var _this10 = (0, _possibleConstructorReturn3.default)(this, (AccountDataExplorer.__proto__ || (0, _getPrototypeOf2.default)(AccountDataExplorer)).call(this, props, context));

        _this10.onBack = _this10.onBack.bind(_this10);
        _this10.editEv = _this10.editEv.bind(_this10);
        _this10._onChange = _this10._onChange.bind(_this10);
        _this10.onQueryEventType = _this10.onQueryEventType.bind(_this10);

        _this10.state = {
            isRoomAccountData: false,
            event: null,
            editing: false,

            queryEventType: ''
        };
        return _this10;
    }

    (0, _createClass3.default)(AccountDataExplorer, [{
        key: 'getData',
        value: function getData() {
            var cli = _MatrixClientPeg2.default.get();
            if (this.state.isRoomAccountData) {
                return cli.getRoom(this.context.roomId).accountData;
            }
            return cli.store.accountData;
        }
    }, {
        key: 'onViewSourceClick',
        value: function onViewSourceClick(event) {
            var _this11 = this;

            return function () {
                _this11.setState({ event: event });
            };
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            if (this.state.editing) {
                this.setState({ editing: false });
            } else if (this.state.event) {
                this.setState({ event: null });
            } else {
                this.props.onBack();
            }
        }
    }, {
        key: '_onChange',
        value: function _onChange(e) {
            this.setState((0, _defineProperty3.default)({}, e.target.id, e.target.type === 'checkbox' ? e.target.checked : e.target.value));
        }
    }, {
        key: 'editEv',
        value: function editEv() {
            this.setState({ editing: true });
        }
    }, {
        key: 'onQueryEventType',
        value: function onQueryEventType(queryEventType) {
            this.setState({ queryEventType: queryEventType });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this12 = this;

            if (this.state.event) {
                if (this.state.editing) {
                    return _react2.default.createElement(SendAccountData, { isRoomAccountData: this.state.isRoomAccountData, onBack: this.onBack, inputs: {
                            eventType: this.state.event.getType(),
                            evContent: (0, _stringify2.default)(this.state.event.getContent(), null, '\t')
                        }, forceMode: true });
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'mx_ViewSource' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_DevTools_content' },
                        _react2.default.createElement(
                            _SyntaxHighlight2.default,
                            { className: 'json' },
                            (0, _stringify2.default)(this.state.event.event, null, 2)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_buttons' },
                        _react2.default.createElement(
                            'button',
                            { onClick: this.onBack },
                            (0, _languageHandler._t)('Back')
                        ),
                        _react2.default.createElement(
                            'button',
                            { onClick: this.editEv },
                            (0, _languageHandler._t)('Edit')
                        )
                    )
                );
            }

            var rows = [];

            var classes = 'mx_DevTools_RoomStateExplorer_button';

            var data = this.getData();
            (0, _keys2.default)(data).forEach(function (evType) {
                var ev = data[evType];
                rows.push(_react2.default.createElement(
                    'button',
                    { className: classes, key: evType, onClick: _this12.onViewSourceClick(ev) },
                    evType
                ));
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_content' },
                    _react2.default.createElement(
                        FilteredList,
                        { query: this.state.queryEventType, onChange: this.onQueryEventType },
                        rows
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_buttons' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.onBack },
                        (0, _languageHandler._t)('Back')
                    ),
                    !this.state.message && _react2.default.createElement(
                        'div',
                        { style: { float: "right" } },
                        _react2.default.createElement('input', { id: 'isRoomAccountData', className: 'mx_DevTools_tgl mx_DevTools_tgl-flip', type: 'checkbox', onChange: this._onChange, checked: this.state.isRoomAccountData }),
                        _react2.default.createElement('label', { className: 'mx_DevTools_tgl-btn', 'data-tg-off': 'Account Data', 'data-tg-on': 'Room Data', htmlFor: 'isRoomAccountData' })
                    )
                )
            );
        }
    }]);
    return AccountDataExplorer;
}(DevtoolsComponent);

AccountDataExplorer.propTypes = {
    onBack: _propTypes2.default.func.isRequired
};


var Entries = [SendCustomEvent, RoomStateExplorer, SendAccountData, AccountDataExplorer];

var DevtoolsDialog = function (_React$Component3) {
    (0, _inherits3.default)(DevtoolsDialog, _React$Component3);

    function DevtoolsDialog(props, context) {
        (0, _classCallCheck3.default)(this, DevtoolsDialog);

        var _this13 = (0, _possibleConstructorReturn3.default)(this, (DevtoolsDialog.__proto__ || (0, _getPrototypeOf2.default)(DevtoolsDialog)).call(this, props, context));

        _this13.onBack = _this13.onBack.bind(_this13);
        _this13.onCancel = _this13.onCancel.bind(_this13);

        _this13.state = {
            mode: null
        };
        return _this13;
    }

    (0, _createClass3.default)(DevtoolsDialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unmounted = true;
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            return { roomId: this.props.roomId };
        }
    }, {
        key: '_setMode',
        value: function _setMode(mode) {
            var _this14 = this;

            return function () {
                _this14.setState({ mode: mode });
            };
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            if (this.prevMode) {
                this.setState({ mode: this.prevMode });
                this.prevMode = null;
            } else {
                this.setState({ mode: null });
            }
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            this.props.onFinished(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            var body = void 0;

            if (this.state.mode) {
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_DevTools_label_left' },
                        this.state.mode.getLabel()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_DevTools_label_right' },
                        'Room ID: ',
                        this.props.roomId
                    ),
                    _react2.default.createElement('div', { className: 'mx_DevTools_label_bottom' }),
                    _react2.default.createElement(this.state.mode, { onBack: this.onBack })
                );
            } else {
                var classes = "mx_DevTools_RoomStateExplorer_button";
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_DevTools_label_left' },
                            (0, _languageHandler._t)('Toolbox')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_DevTools_label_right' },
                            'Room ID: ',
                            this.props.roomId
                        ),
                        _react2.default.createElement('div', { className: 'mx_DevTools_label_bottom' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_Dialog_content' },
                            Entries.map(function (Entry) {
                                var label = Entry.getLabel();
                                var onClick = _this15._setMode(Entry);
                                return _react2.default.createElement(
                                    'button',
                                    { className: classes, key: label, onClick: onClick },
                                    label
                                );
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_Dialog_buttons' },
                        _react2.default.createElement(
                            'button',
                            { onClick: this.onCancel },
                            (0, _languageHandler._t)('Cancel')
                        )
                    )
                );
            }

            var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
            return _react2.default.createElement(
                BaseDialog,
                { className: 'mx_QuestionDialog', onFinished: this.props.onFinished, title: (0, _languageHandler._t)('Developer Tools') },
                body
            );
        }
    }]);
    return DevtoolsDialog;
}(_react2.default.Component);

DevtoolsDialog.childContextTypes = {
    roomId: _propTypes2.default.string.isRequired
    // client: PropTypes.instanceOf(MatixClient),
};
DevtoolsDialog.propTypes = {
    roomId: _propTypes2.default.string.isRequired,
    onFinished: _propTypes2.default.func.isRequired
};
exports.default = DevtoolsDialog;
module.exports = exports['default'];
//# sourceMappingURL=DevtoolsDialog.js.map